/** @format */
import {
  Auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updatePassword,
  sendPasswordResetEmail,
  authState,
  onAuthStateChanged,
} from '@angular/fire/auth';
import { DbService } from './db.service';
import { AlertService } from './alert.service';
import { Observable, lastValueFrom, of, switchMap, take } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$: Observable<any>;

  constructor(public alertService: AlertService, private db: DbService, private auth: Auth) {
    this.user$ = authState(auth).pipe(switchMap(user => (user ? this.db.doc$(`members/${user.uid}`) : of(null))));
    // .pipe(
    //   map((user) => {
    //     // 코드 필요한 경우
    //     return user;
    //   })
    // );
  }

  // email + password 가입
  registerUser(value) {
    return new Promise<any>((resolve, reject) => {
      createUserWithEmailAndPassword(this.auth, value.email, value.password).then(
        success => resolve(success),
        error => {
          this.showErrorMessage(error);
          reject(error);
        }
      );
    });
  }

  // 로그인했는지 여부
  checkLoggedIn(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      onAuthStateChanged(this.auth, (user) => {
        if (user) {
          resolve(user.uid);
        } else {
          resolve('');
        }
      });
    });
  }

  // email + password 로그인
  loginUser(value) {
    return new Promise<any>((resolve, reject) => {
      signInWithEmailAndPassword(this.auth, value.email, value.password).then(
        success => resolve(success),
        error => {
          this.showErrorMessage(error);
          reject(error);
        }
      );
    });
  }

  // 가입한 회원에게 이메일 인증 메일 발송
  sendEmailVerificationUser(user) {
    return new Promise((resolve, reject) => {
      if (this.auth.currentUser) {
        user.sendEmailVerification().then(
          success => resolve(success),
          error => {
            this.showErrorMessage(error);
            reject(error);
          }
        );
      }
    });
  }

  // 현재 currentUser 로그아웃
  logoutUser() {
    return new Promise((resolve, reject) => {
      signOut(this.auth).then(
        success => resolve(success),
        error => {
          this.showErrorMessage(error);
          reject(error);
        }
      );
    });
  }

  // 현재 currentUser 회원탈퇴 (주의사항 : currentUser가 최신이 아닐 경우 재 로그인 필요)
  exitUser() {
    return new Promise((resolve, reject) => {
      this.auth.currentUser.delete().then(
        success => resolve(success),
        error => {
          this.showErrorMessage(error);
          reject(error);
        }
      );
    });
  }

  // currentUser 정보 받아오기
  async getUser() {
    return await lastValueFrom(this.user$.pipe(take(1)));
  }

  // currentUser uid 받아오기
  uid() {
    return this.auth.currentUser?.uid;
  }

  // currentUser 비밀번호 변경
  async changePassword(newPassword) {
    return new Promise((resolve, reject) => {
      updatePassword(this.auth.currentUser, newPassword).then(
        success => resolve(success),
        error => {
          this.showErrorMessage(error);
          reject(error);
        }
      );
    });
  }

  // 비밀번호 재설정 메일 발송
  sendPasswordReset(email) {
    return new Promise((resolve, reject) => {
      sendPasswordResetEmail(this.auth, email).then(
        success => resolve(success),
        error => {
          this.showErrorMessage(error);
          reject(error);
        }
      );
    });
  }

  async showErrorMessage(code$: any) {
    let code = await code$;
    switch (code) {
      // Firebase Error Messages
      case 'auth/email-already-exists':
        this.alertService.errormsg('이미 있는 계정입니다.', '회원 가입 오류');
        break;
      case 'auth/invalid-credential':
        this.alertService.errormsg('로그인 인증에 오류가 발생했습니다.', '인증 오류');
        break;
      case 'auth/operation-not-allowed':
        this.alertService.errormsg('로그인 과정에서 오류가 발생했습니다. 관리자에게 문의하시길 바랍니다.', '로그인 실패');
        break;

      case 'auth/user-not-found':
        this.alertService.errormsg('가입된 이메일 주소가 아닙니다. 다시 확인하시기 바랍니다.', '이메일 없음');
        break;
      case 'auth/invalid-login-credentials':
        this.alertService.errormsg('이메일 주소 또는 비밀번호가 틀립니다.\n 확인 후 다시 입력해주세요.', '로그인 오류');
        break;
      case 'auth/invalid-email':
        this.alertService.errormsg('이메일 주소 또는 비밀번호가 틀립니다.\n 확인 후 다시 입력해주세요.', '로그인 오류');
        break;
      case 'auth/invalid-password':
        this.alertService.errormsg('비밀번호는 6자 이상이여야합니다.', '회원가입 오류');
        break;
      case 'auth/id-token-expired':
        this.alertService.errormsg('제공된 로그인 토큰이 만료되었습니다.', '인증만료');
        break;
      case 'auth/too-many-requests':
        this.alertService.errormsg('로그인 요청 횟수가 초과 되었습니다. 잠시 후 다시 시도하시기 바랍니다.', '요청 횟수 초과');
        break;

      default:
        this.alertService.errormsg('로그인 인증에 오류가 발생했습니다.', '관리자 문의');
    }
  }
}
